/** @param {string} trimmed */
function normalizePrompt(trimmed) {
  return String(trimmed ?? '').trim().replace(/\s+/g, ' ').toLowerCase()
}

/** @param {string} trimmed */
export function isAcmeInsuranceRenewalMondayTriggerPrompt(trimmed) {
  const normalized = normalizePrompt(trimmed)
  return (
    normalized.includes('updated version') &&
    normalized.includes('monday')
  )
}

/**
 * @param {unknown[]} priorMessages
 * @returns {boolean}
 */
export function threadAwaitingAcmeInsuranceRenewalMondayTrigger(priorMessages) {
  if (!Array.isArray(priorMessages) || priorMessages.length === 0) return false

  for (let i = priorMessages.length - 1; i >= 0; i--) {
    const message = priorMessages[i]
    if (!message || typeof message !== 'object') continue

    const role = /** @type {{ role?: string }} */ (message).role
    if (role !== 'assistant') continue

    const assistant = /** @type {{
      acmeInsuranceRenewalAwaitingMondayTrigger?: boolean,
      acmeInsuranceRenewalMondayTriggerCompleted?: boolean,
    }} */ (message)

    if (assistant.acmeInsuranceRenewalMondayTriggerCompleted) return false
    return assistant.acmeInsuranceRenewalAwaitingMondayTrigger === true
  }

  return false
}
